import { askDockTab } from "./dockBridge.js";

// Jobs a surface runs for the reader outside a chat's own turns (the board's
// "Walk me through it" walking through it), put in the chat in front as the
// card the chat's own call of that job shows (components/ChatConsole.jsx
// JobNode), the chat brought in front. Run so, a job is the reader's own
// click, never the model's choice, so a chat that knows the traces already
// cannot answer in its place.
const listeners = new Set();
let seq = 0;

/**
 * Puts job `{ kind, key }` (kind "walkthrough": `key` the walkthrough's)
 * in the chat in front. False where no chat console is up to take it.
 */
export function postChatJob(job) {
    if (!job?.kind || !job.key || !listeners.size) return false;
    seq += 1;
    const item = { kind: "job", id: `job-${Date.now().toString(36)}-${seq}`, job: String(job.kind), key: String(job.key), at: Date.now(), ...(job.chatId != null ? { targetChatId: job.chatId } : {}),
        ...(job.kind === "policyChat" && job.policyView ? { policyView: job.policyView } : {}),
        ...(["policyChat", "controlProposal", "controlProposalEntry"].includes(job.kind) && job.reveal ? { policyReveal: true } : {}) };
    for (const fn of listeners) fn(item);
    if (job.chatId == null) askDockTab("chat");
    return true;
}

export function onChatJob(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}

export function appendChatJob(items, row) {
    const previous = items || [];
    if (["policyChat", "controlProposal", "controlProposalEntry"].includes(row.job) && (row.key?.endsWith("|active") || row.key?.endsWith("|entry")) && previous.some((item) => item.kind === "job" && item.key === row.key)) {
        return row.policyReveal ? [...previous.filter((item) => item.kind !== "job" || item.key !== row.key), row] : previous;
    }
    return [...previous, row];
}

const patchListeners = new Set();

/// Merges `patch` into the job row with `key`, in whichever chat holds it, so
/// what the job keeps is saved with the chat.
export function patchChatJob(key, patch) {
    for (const fn of patchListeners) fn(String(key), patch);
}

export function onChatJobPatch(fn) {
    patchListeners.add(fn);
    return () => patchListeners.delete(fn);
}

/// `chats` with `patch` merged into every job row whose key is `key`. A chat
/// that holds no such row is returned as the same object.
export function patchJobRows(chats, key, patch) {
    const holds = (it) => it?.kind === "job" && it.key === key;
    return chats.map((c) => ((c.items || []).some(holds) ? { ...c, items: c.items.map((it) => (holds(it) ? { ...it, ...patch } : it)) } : c));
}
